import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

export interface IConfirmModalOptions {
    isOpen: boolean;
    text?: string;
    children?: unknown;
    confirmCallback(val: any): void;
    cancelCallback(err: any): void;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

export const ConfirmModal = ({
    isOpen,
    text,
    children,
    confirmCallback,
    cancelCallback,
    confirmButtonText = 'Confirm',
    cancelButtonText = 'Cancel',
}: IConfirmModalOptions): React.ReactElement => {
    const _handleConfirm = () => confirmCallback('Confirm');
    const _handleCancel = () => cancelCallback('Cancel');

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogContent>
                    {children}
                    {!children && (
                        <DialogContentText id='alert-dialog-description'>
                            <div dangerouslySetInnerHTML={{ __html: text }} />
                        </DialogContentText>
                    )}
                </DialogContent>
                <DialogActions>
                    <button
                        type='button'
                        className='button primary'
                        onClick={_handleConfirm}
                    >
                        {confirmButtonText}
                    </button>
                    <button
                        type='button'
                        className='button hollow'
                        onClick={_handleCancel}
                    >
                        {cancelButtonText}
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
